import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChatbotRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M3.2 4.8a1.2 1.2 0 0 1 1.2-1.2h7.202a1.2 1.2 0 0 1 1.2 1.2v5.6a1.2 1.2 0 0 1-1.2 1.2h-2.61c-.248 0-.49.077-.693.22L6 13.442V12.2c0-.333-.268-.6-.6-.6h-1a1.2 1.2 0 0 1-1.2-1.2zm1.2-2.4A2.4 2.4 0 0 0 2 4.8v1.6H.6c-.333 0-.6.267-.6.6s.267.6.6.6H2v2.8a2.4 2.4 0 0 0 2.4 2.4h.4v1.8a.6.6 0 0 0 .948.49l3.244-2.29h2.61a2.4 2.4 0 0 0 2.4-2.4V7.6h1.4c.333 0 .6-.268.6-.6 0-.333-.267-.6-.6-.6h-1.4V4.8a2.4 2.4 0 0 0-2.4-2.4zm2.001 2.4a2.4 2.4 0 0 0 0 4.8h3.2a2.4 2.4 0 0 0 0-4.8zm0 1.6a.8.8 0 1 1 .002 1.598A.8.8 0 0 1 6.4 6.4m2.4.8a.8.8 0 1 1 1.599-.002A.8.8 0 0 1 8.8 7.2" })
});
export default SvgChatbotRegularIcon;
